import {Component, OnInit, Inject, OnDestroy} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar} from '@angular/material';
import {takeUntil} from 'rxjs/operators';
import {componentDestroyed} from '@w11k/ngx-componentdestroyed';

import {BranchSetService} from '../branch-set.service';
import {BranchSet} from '../branch-set.model';

@Component({
  selector: 'app-branch-set-delete-dialog',
  templateUrl: './branch-set-delete-dialog.component.html',
  styleUrls: ['../branch-set.component.css']
})
export class BranchSetDeleteDialogComponent implements OnInit, OnDestroy {
  branchSet: BranchSet;
  errorMessage: string;
  constructor(private branchSetService: BranchSetService,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private snackBar: MatSnackBar,
              public dialogRef: MatDialogRef<BranchSetDeleteDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: BranchSet) {
    this.branchSet = data;
  }

  ngOnInit() {
  }
  ngOnDestroy(): void {
  }

  delete() {
    this.errorMessage = '';
    this.branchSetService.deleteBranchSet(this.branchSet.id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(response => this.onSaveSuccess(response), (response) => this.onSaveError(response));
  }

  onSaveSuccess(result) {
    this.dialogRef.close('deleted');


  }

  onSaveError(response) {
    this.errorMessage = response;
  }

  cancel(): void {
    this.dialogRef.close('canceled');
  }
}
